module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.acf3dcb7.svg";